import axios from "axios";
import { isValid } from "date-fns";
import Swal from "sweetalert2";
import React from "react";
import { renderToString } from 'react-dom/server'
import { CheckIcon, ExclamationCircleIcon, ExclamationTriangleIcon, XMarkIcon } from "@heroicons/react/24/outline";

export const imagemCartao = (flag) => {
	return (<img alt="Logo" src={`../images/${flag}.png`} style={{ width: 175 }} />)
}

export const createFormikValidation = (formMap, values) => {
	const errors = {};

	for (let [key, value] of formMap) {
		if (!values[key] && values[key] !== 0) {
			errors[key] = "O campo " + value + " é obrigatório.";
		} else if (key.includes("email") && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values[key])) {
			errors[key] = "Você precisa informar um e-mail válido.";
		} else if ((key.includes("senha") || key.includes("password")) && values[key].length < 6) {
			errors[key] = "A senha deve ter pelo menos 6 caracteres.";
		} else if (key.includes("cep") && values[key].length < 9) {
			errors[key] = "Utilize no mínimo 8 caracteres.";
		} else if (key.includes("cpf") && key.includes("cnpj")) {
			if (values[key].length > 14 && !validaCnpj(values[key])) {
				errors[key] = "O CNPJ informado é inválido.";
			} else if (values[key].length <= 14 && !validaCpf(values[key])) {
				errors[key] = "O CPF informado é inválido.";
			}
		} else if (key.includes("cpf") && !validaCpf(values[key])) {
			errors[key] = "O CPF informado é inválido.";
		} else if (key.includes("cnpj") && !validaCnpj(values[key])) {
			errors[key] = "O CNPJ informado é inválido.";
		} else if (key.includes("telefone")) {
			if (values[key].length < 14) {
				errors[key] = "Utilize no mínimo 10 números.";
			} else if (!values[key] || /^(\d)\1+$/.test(values[key].replace(/\D/g, ""))) {
				errors[key] = "Telefone inválido.";
			}
		} else if (key.includes("data_") && !isValid(new Date(values[key]))) {
			errors[key] = "Data inválida.";
		} else if ((key.includes("logradouro") || key.includes("bairro")) && /^[0-9]+$/.test(values[key])) {
			errors[key] = "O campo deve conter pelo menos um caractere não numérico.";
		}
	}

	return errors;
};

export const capitalize = (string) => {
	if (!string || string.length === 0) {
		return "";
	}

	return string.charAt(0).toUpperCase() + string.slice(1);
}

export const shallowEqual = (object1, object2) => {
	const keys1 = Object.keys(object1);
	const keys2 = Object.keys(object2);

	if (keys1.length !== keys2.length) {
		return false;
	}

	for (let key of keys1) {
		if (object1[key] !== object2[key]) {
			return false;
		}
	}

	return true;
};

export const formatBRLInput = (input) => {
	let value = input.target.value.toString().replace(/[^0-9]/g, "");

	value = Number(value) / 100;
	input.target.value = formatBRL(value);

	return input;
};

export const formatBRL = (value) => {
	const formatter = new Intl.NumberFormat("pt-BR", {
		style: "currency",
		currency: "BRL",
		minimumFractionDigits: 2,
	});

	value = formatter.format(value);

	return value;
};

export const formatHourInput = (input) => {
	let value = input.target.value;

	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{2})(\d)/, "$1:$2");

	input.target.value = value;

	return input;
};

export const formatCepInput = (input) => {
	let value = input?.target?.value?.toString() ?? "";

	value = value?.replace(/\D/g, "");
	value = value?.replace(/(\d{5})(\d)/, "$1-$2");

	if (input) {
		input.target.value = value;
	}

	return input;
};

export const formatCPFInput = (input) => {
	let value = input.target.value;

	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{3})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

	input.target.value = value;

	return input;
};

export const formatDataInput = (input) => {
	let value = input.target.value;

	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{2})(\d)/, "$1/$2");
	value = value.replace(/(\d{2})(\d)/, "$1/$2");

	input.target.value = value;

	return input;
};

export const formatIntegerInput = (input, min = null, max = null) => {
	// Remove tudo que não for número
	const value = input.target.value.toString().replace(/[^0-9]/g, "");

	// Converte para número inteiro
	let numericValue = value ? parseInt(value, 10) : "";

	// Se for 0, limpar
	if (numericValue === 0) {
		input.target.value = "";
		return input;
	}

	// Aplicar limites se definidos
	if (numericValue !== "") {
		if (min !== null && numericValue < min) {
			numericValue = min;
		}
		if (max !== null && numericValue > max) {
			numericValue = max;
		}
	}

	input.target.value = numericValue;

	return input;
};

export const formatCVV = (e) => {
	let value = e.target.value;

	value = value.replace(/\D/g, "");

	e.target.value = value;

	return e;
};

export const formataCCVencimento = (e) => {
	let vencimento = e.target.value;

	vencimento = vencimento.replace(/\D/g, "");
	vencimento = vencimento.replace(/(\d{2})(\d)/, "$1/$2");
	e.target.value = vencimento

	return e;
};

export const formatTelefoneInput = (input) => {
	let value = input.target.value;

	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{0})(\d)/, "$1($2");
	value = value.replace(/(\d{2})(\d)/, "$1) $2");
	value = value.replace(/(\d{1})(\d{1,4})$/, "$1-$2");

	input.target.value = value;

	return input;
};

export const buscaCepRequest = (input) => {
	return new Promise((resolve, reject) => {
		var cep = input.replace(/[^0-9]/, "");

		const instance = axios.create();

		instance
			.get(`https://viacep.com.br/ws/${cep}/json`, {})
			.then((res) => {
				if (res.data.erro) {
					return reject(res.data.erro);
				}

				return resolve(res.data);
			})
			.catch((err) => {
				reject();
			});
	});
};

export const buscaCep = (input, setFieldValue, nomeEndereco, nomeBairro, nomeCidade, nomeUf, onLoading) => {
	if (input.target.value.length > 8) {
		var cep = input.target.value.replace(/[^0-9]/, "");

		const instance = axios.create();

		if (onLoading) {
			onLoading(true);
		}

		instance
			.get(`https://viacep.com.br/ws/${cep}/json/`, {})
			.then((res) => {
				if (res.data.erro) {
					setFieldValue(nomeEndereco, "");
					setFieldValue(nomeBairro, "");
					setFieldValue(nomeCidade, "");
					setFieldValue(nomeUf, "AC");
				} else {
					setFieldValue(nomeEndereco, res.data.logradouro ?? "");
					setFieldValue(nomeBairro, res.data.bairro ?? "");
					setFieldValue(nomeCidade, res.data.localidade ?? "");
					setFieldValue(nomeUf, res.data.uf ?? "");
				}
			})
			.catch((err) => { })
			.finally(() => {
				if (onLoading) {
					onLoading(false);
				}
			});
	}

	return formatCepInput(input);
};

export const listaUfs = ["AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO", "MA", "MG", "MS", "MT", "PA", "PB", "PE", "PI", "PR", "RJ", "RN", "RO", "RR", "RS", "SC", "SE", "SP", "TO"];

export const listaUfsExtenso = [
	{ key: "AC", label: "Acre" },
	{ key: "AL", label: "Alagoas" },
	{ key: "AP", label: "Amapá" },
	{ key: "AM", label: "Amazonas" },
	{ key: "BA", label: "Bahia" },
	{ key: "CE", label: "Ceará" },
	{ key: "DF", label: "Distrito Federal" },
	{ key: "ES", label: "Espírito Santo" },
	{ key: "GO", label: "Goiás" },
	{ key: "MA", label: "Maranhão" },
	{ key: "MT", label: "Mato Grosso" },
	{ key: "MS", label: "Mato Grosso do Sul" },
	{ key: "MG", label: "Minas Gerais" },
	{ key: "PA", label: "Pará" },
	{ key: "PB", label: "Paraíba" },
	{ key: "PR", label: "Paraná" },
	{ key: "PE", label: "Pernambuco" },
	{ key: "PI", label: "Piauí" },
	{ key: "RJ", label: "Rio de Janeiro" },
	{ key: "RN", label: "Rio Grande do Norte" },
	{ key: "RS", label: "Rio Grande do Sul" },
	{ key: "RO", label: "Rondônia" },
	{ key: "RR", label: "Roraima" },
	{ key: "SC", label: "Santa Catarina" },
	{ key: "SP", label: "São Paulo" },
	{ key: "SE", label: "Sergipe" },
	{ key: "TO", label: "Tocantins" },
];

export const listaFormatoImagens = ['jpg', 'jpeg']

/* eslint-disable */
export const validaCpf = (cpf) => {
	var add = 0;
	var rev = 0;

	cpf = cpf.replace(/[^\d]+/g, "");
	if (cpf == "") return false;

	if (cpf.length != 11) return false;

	for (var i = 0; i < 9; i++) {
		add += parseInt(cpf.charAt(i)) * (10 - i);
	}

	rev = 11 - (add % 11);

	if (rev == 10 || rev == 11) {
		rev = 0;
	}
	if (rev != parseInt(cpf.charAt(9))) {
		return false;
	}

	add = 0;

	for (var j = 0; j < 10; j++) {
		add += parseInt(cpf.charAt(j)) * (11 - j);
	}

	rev = 11 - (add % 11);

	if (rev == 10 || rev == 11) {
		rev = 0;
	}

	if (rev != parseInt(cpf.charAt(10))) {
		return false;
	}

	return true;
};
/* eslint-enable */

export const validaCnpj = (cnpj) => {
	cnpj = cnpj.replace(/[^\d]+/g, "");

	if (cnpj.length !== 14) {
		return false;
	}

	if (/^(\d)\1+$/.test(cnpj)) {
		return false;
	}

	let add = 0;
	let rev = 0;
	let pos = 5;

	for (let i = 0; i < 12; i++) {
		add += parseInt(cnpj.charAt(i)) * pos;
		pos = pos === 2 ? 9 : pos - 1;
	}

	rev = add % 11 < 2 ? 0 : 11 - (add % 11);

	if (rev !== parseInt(cnpj.charAt(12))) {
		return false;
	}

	add = 0;
	pos = 6;

	for (let i = 0; i < 13; i++) {
		add += parseInt(cnpj.charAt(i)) * pos;
		pos = pos === 2 ? 9 : pos - 1;
	}

	rev = add % 11 < 2 ? 0 : 11 - (add % 11);

	return rev === parseInt(cnpj.charAt(13));
};

export const formatCNPJInput = (input) => {
	let value = input.target.value;

	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{2})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d)/, "$1/$2");
	value = value.replace(/(\d{4})(\d{1,2})$/, "$1-$2");

	input.target.value = value;

	return input;
};

export const formatCPFCNPJInput = (input) => {
	const digits = input.target.value.replace(/\D/g, "");
	let value = digits;

	if (digits.length > 11) {
		value = value.replace(/(\d{2})(\d)/, "$1.$2");
		value = value.replace(/(\d{3})(\d)/, "$1.$2");
		value = value.replace(/(\d{3})(\d)/, "$1/$2");
		value = value.replace(/(\d{4})(\d{1,2})$/, "$1-$2");
	} else {
		value = value.replace(/(\d{3})(\d)/, "$1.$2");
		value = value.replace(/(\d{3})(\d)/, "$1.$2");
		value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
	}

	input.target.value = value;

	return input;
};

export const textoExclusao = {
	title: "Atenção!",
	text: "Tem certeza que deseja remover?",
	icon: "warning",
	showCancelButton: true,
	confirmButtonColor: "#3085d6",
	cancelButtonColor: "#d33",
	cancelButtonText: "Não",
	confirmButtonText: "Sim",
};

export const limparMoeda = (valor, parse = false) => {
	valor = valor.replaceAll("R$", "");
	valor = valor.replaceAll(".", "");
	valor = valor.replaceAll(",", ".");
	valor = valor.replaceAll("/^p{Z}+|p{Z}+$/u", "");
	valor = valor.trim();

	return parse ? parseFloat(valor) : valor;
};

export const formatNumberToPtBr = (number, maximumFractionDigits = 2, minimumFractionDigits) => number.toLocaleString("pt-BR", { maximumFractionDigits, minimumFractionDigits });

export const formatLargeNumberToString = (num) => {
	const format = ({ value, minimumFractionDigits, maximumFractionDigits }) => {
		const formatter = new Intl.NumberFormat("pt-BR", {
			style: "decimal",
			minimumFractionDigits,
			maximumFractionDigits,
		});

		return formatter.format(value);
	};

	if (num >= 1e9) {
		return format({ value: num / 1e9, maximumFractionDigits: 1 }) + "b"; // Bilhão
	} else if (num >= 1e6) {
		return format({ value: num / 1e6, maximumFractionDigits: 1 }) + "m"; // Milhão
	} else if (num >= 1e3) {
		return format({ value: num / 1e3, maximumFractionDigits: 1 }) + "k"; // Milha
	} else {
		return num.toString(); // Menos que uma milha
	}
};

export const formatNumberToPtBrDoubleInput = (input, min, max) => {
	let value = input.target.value;

	// Remove everything that is not a digit (non-numeric characters)
	value = value.replace(/\D/g, "");

	if (value === "") {
		value = "0";
	}

	// Convert to a double number with two decimal places
	let numericValue = parseFloat(value) / 100;

	if (typeof min === "number" && numericValue < min) {
		numericValue = min;
	} else if (typeof max === "number" && numericValue > max) {
		numericValue = max;
	}

	// Format the number using pt-BR locale with comma as decimal separator
	input.target.value = numericValue.toLocaleString("pt-BR", {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});

	return input;
};

export const isset = (value) => {
	return value !== null && value !== undefined;
};

export const getCardFlag = (value) => {
	const card = value?.replace(/[^0-9]+/g, "");

	const cards = {
		elo: /^(4011|4312|4389|4514|4576|5041|5067|5090|6277|6362|6363|6504|6505|6507|6509|6516|6550|6551|6552)\d{12,15}$/,
		visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
		mastercard: /^5[1-5][0-9]{14}$/,
		diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
		discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
		hipercard: /^6062|3841/,
		jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
		amex: /^3[47][0-9]{13}$/,
		aura: /^50[0-9]{14}$/,
	};

	for (const flag in cards) {
		if (cards[flag].test(card)) {
			return flag;
		}
	}

	return "";
};

export const BANDEIRAS_CARTAO = ["amex", "aura", "diners", "discover", "elo", "hipercard", "jcb", "mastercard", "visa"];

export const getBandeiraComLogo = (bandeira) => {
	const normalizada = typeof bandeira === "string" ? bandeira.trim().toLowerCase() : "";

	return BANDEIRAS_CARTAO.includes(normalizada) ? normalizada : "";
};

export const formatNumeroCartao = (input, cardFlag = null) => {
	const cleaned = input.target.value.replace(/[^0-9*]/g, "");
	const cardType = cardFlag ?? getCardFlag(cleaned);

	// Aplica a máscara conforme o tipo
	switch (cardType) {
		case "amex": // 15 dígitos: #### ###### #####
			input.target.value = cleaned.replace(/^([\d\*]{0,4})([\d\*]{0,6})([\d\*]{0,5})/, "$1 $2 $3").trim();
			break;
		case "diners": // 14 dígitos: #### ###### ####
			input.target.value = cleaned.replace(/^([\d\*]{0,4})([\d\*]{0,6})([\d\*]{0,4})/, "$1 $2 $3").trim();
			break;
		case "elo":
		case "hipercard":
		case "visa":
		case "mastercard":
		case "discover":
		case "jcb":
		default:
			// Até 19 dígitos, formatado em blocos de 4
			input.target.value = cleaned.replace(/(.{1,4})/g, "$1 ").trim();
			break;
	}

	return input;
};

export const clearString = (text = "") => {
	return text.replace(/[^\p{L}\p{N}]/gu, "");
};


export const listaSegmentos = [
	{
		label: 'Atendimento ao cliente',
		value: 'ATENDIMENTO'
	},
	{
		label: 'Indústria e Manufatura',
		value: 'INDUSTRIA'
	},
	{
		label: 'Serviços administrativos',
		value: 'ADMINISTRATIVOS'
	},
	{
		label: 'Serviços de saúde',
		value: 'SAUDE'
	},
	{
		label: 'Serviços financeiros',
		value: 'FINANCEIROS'
	},
	{
		label: 'Tecnologia da informação',
		value: 'TECNOLOGIA'
	},
	{
		label: 'Varejo e Logística',
		value: 'VAREJO'
	},
	{
		label: 'Outros',
		value: 'OUTROS'
	}
]

export const motivosCancelamento = [
	{
		value: 'CUSTO',
		label: 'Custo do plano'
	},
	{
		value: 'POUCO_USO',
		label: 'Pouco uso da plataforma'
	},
	{
		value: 'FUNCIONALIDADE',
		label: 'Funcionalidades limitadas'
	},
	{
		value: 'DIFICULDADE',
		label: 'Dificuldade de uso'
	},
	{
		value: 'EXPECTATIVA',
		label: 'Não atendeu às expectativas'
	},
	{
		value: 'SUPORTE',
		label: 'Suporte/Atendimento ruim'
	},
	{
		value: 'NECESSIDADE',
		label: 'Necessidades mudaram'
	},
	{
		value: 'OUTRO',
		label: 'Outros'
	},
]

export const niveisDeAcesso = [
	{
		value: 'COLABORADOR',
		label: 'Colaborador'
	},
	{
		value: 'ADMINISTRADOR',
		label: 'Administrador'
	}
]

export const statusPagamento = (valor) => {
	const status = {
		ABERTA: {
			label: 'Aberta',
			color: 'warning'
		},
		AGUARDANDO: {
			label: 'Aguardando',
			color: 'warning'
		},
		CANCELADO: {
			label: 'Cancelado',
			color: 'danger'
		},
		PAGO: {
			label: 'Pago',
			color: 'success'
		}
	}

	return status[valor] || { label: 'Outro', color: 'primary' }
}

export const tipoPagamento = (valor) => {
	const tipos = {
		ASSINATURA: 'Mensalidade',
		AJUSTE_PROPORCIONAL: 'Ajuste proporcional'
	}

	return tipos[valor] || 'Mensalidade'
}

export const coresPie = ['#40156B', '#541C8C', '#6D24B5', '#8B2EE8', '#9933FF', '#AD5CFF', '#BB76FF', '#D0A1FF'];

export const coresComponente = {
	roxo: '#8B2EE8',
	roxo_escuro: '#541C8C',
	vermelho: '#EF5350',
	amarelo: '#FFA726',
	verde: '#66BB6A'
}

export const confirmacao = (mensagem) => {
	return Swal.fire({
		title: "Atenção!",
		text: mensagem,
		icon: "warning",
		showCancelButton: true,
		confirmButtonColor: "#3085d6",
		cancelButtonColor: "#d33",
		cancelButtonText: "Não",
		confirmButtonText: "Sim",
	})
}

export const downloadCSV = (config) => {
	const {
		data = [],
		columns = [],
		filename = "export",
		separator = ";",
		lineBreak = "\n"
	} = config;

	if (!data || data.length === 0) {
		console.warn("Nenhum dado disponível para exportar");
		return;
	}

	if (!columns || columns.length === 0) {
		console.warn("Nenhuma coluna definida para exportar");
		return;
	}

	const header = columns.map(col => `"${col.header || ""}"`).join(separator);

	const rows = data.map(item => {
		return columns.map(col => {
			let value = "";

			if (col.key) {
				const keys = col.key.split(".");
				value = keys.reduce((obj, key) => obj?.[key], item);
			}

			if (col.formatter && typeof col.formatter === "function") {
				value = col.formatter(value, item);
			}

			if (value === null || value === undefined) {
				value = "";
			}

			value = String(value).replace(/"/g, '""');

			return `"${value}"`;
		}).join(separator);
	});

	const csv = [header, ...rows].join(lineBreak);

	const BOM = "\uFEFF";
	const csvContent = BOM + csv;

	const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
	const link = document.createElement("a");
	const url = URL.createObjectURL(blob);

	link.setAttribute("href", url);
	link.setAttribute("download", `${filename}.csv`);
	link.style.visibility = "hidden";

	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);

	URL.revokeObjectURL(url);
}

export const testeDeEmail = email => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email);

export const swalCustom = (titulo, mensagem, tipo, options = {}) => {
	const icon = {
		success: (<div className="icon-sweet success"><CheckIcon /></div>),
		error: (<div className="icon-sweet error"><XMarkIcon /></div>),
		info: (<div className="icon-sweet info"><ExclamationCircleIcon /></div>),
		warning: (<div className="icon-sweet warning"><ExclamationTriangleIcon /></div>)
	};

	const iconHtmlString = renderToString(icon[tipo] || icon.info);

	return Swal.fire({
		title: titulo,
		html: `<div class="custom-content">
            ${iconHtmlString}
            <p class="mensagem">${mensagem}</p>
        </div>`,
		showConfirmButton: true,
		confirmButtonText: options.confirmButtonText || 'Fechar',
		showCancelButton: options.showCancelButton || false,
		cancelButtonText: options.cancelButtonText || 'Cancelar',
		buttonsStyling: false,
		customClass: {
			popup: 'custom-swal-popup',
			title: 'custom-swal-title',
			confirmButton: 'custom-swal-button',
			cancelButton: 'custom-swal-cancel-button',
			icon: 'custom-swal-icon-container'
		},
		...options
	});
};

export const validarCartao = (numeroCartao, cvv, vencimento, flag) => {
	const numero = (numeroCartao || "").replace(/[^0-9*]/g, "");
	const codigoCvv = (cvv || "").replace(/[^0-9]/g, "");
	const dataVencimento = (vencimento || "").replace(/[^0-9]/g, "");
	const bandeira = flag ? flag.toLowerCase() : "";
	const minDigitos = bandeira === 'amex' ? 15 : 16;
	const tamanhoCvvEsperado = bandeira === 'amex' ? 4 : 3;

	if (numero.length < minDigitos || numero.length > 19) {
		swalCustom("Ops!", `O número do cartão deve ter no mínimo ${minDigitos} e no máximo 19 dígitos.`, 'info');
		return false;
	}

	if (codigoCvv.length !== tamanhoCvvEsperado) {
		swalCustom("Ops!", `O CVV para a bandeira ${bandeira.toUpperCase() || 'selecionada'} deve ter exatamente ${tamanhoCvvEsperado} dígitos.`, 'info');
		return false;
	}

	if (dataVencimento.length !== 6) {
		swalCustom("Ops!", 'Insira uma data válida no formato MM/AAAA.', 'info');
		return false;
	}

	const mes = parseInt(dataVencimento.substring(0, 2), 10);
	let ano = parseInt(dataVencimento.substring(2), 10);

	if (dataVencimento.length === 4) {
		ano += 2000;
	}

	if (mes < 1 || mes > 12) {
		swalCustom("Ops!", 'Mês de vencimento inválido.', 'info');
		return false;
	}

	const dataAtual = new Date();
	const anoAtual = dataAtual.getFullYear();
	const mesAtual = dataAtual.getMonth() + 1;

	if (ano < anoAtual || (ano === anoAtual && mes < mesAtual)) {
		swalCustom("Ops!", 'Este cartão já está vencido.', 'info');
		return false;
	}

	return true;
}